module.exports = __webpack_public_path__ + "static/media/Starjedi.cc3019aa.ttf";